import {
  SaveBaseHeadPositionParam,
  SaveHeadPositionParam,
} from 'api/types/params';
import { formatToISODate } from 'helpers';
import { YesOrNoType } from 'types/yesOrNo';

import {
  BaseHeadPositionFormType,
  HeadPositionFormType,
} from '../../forms/headPositionForm';

export const getBaseSubmitData = (
  values: BaseHeadPositionFormType
): SaveBaseHeadPositionParam => ({
  positionInCompany: values.position,
  positionConfirmationFileIds: values.positionConfirmationFileIds ?? [],
  expirationDate: values.dateOfExpiration
    ? formatToISODate(values.dateOfExpiration)
    : undefined,
});

export const getSubmitData = (
  values: HeadPositionFormType
): SaveHeadPositionParam => ({
  ...getBaseSubmitData(values),
  isFirstHead: values.firstHead?.value === YesOrNoType.Yes,
  legalClientBodyIds:
    values.bodies?.filter((v) => v.value !== '-1').map((v) => v.value) ?? [],
  hasLegalClientBody: !values.bodies?.some((v) => v.value === '-1'),
});
